module.exports = __webpack_public_path__ + "static/media/globe-snow.834b9dbe.svg";